import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAuthHook from "./useAuthHook";

const useSetUserByParams = () => {
  const { setJWT, signOut } = useAuthHook();

  const location = useLocation();

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const token = search.get("token");
    const refresh_token = search.get("refresh_token");
    if (token && refresh_token) {
      signOut();
      setJWT({ token, refresh_token });
    }
  }, [location]);
};

export default useSetUserByParams;
